import { InlineAlert } from '../../components/BaseComponents'
import { useState } from "react";
import { Button } from "../../components/BaseComponents";
import CanonicalModal from "../../components/BaseComponents/CanonicalModal/CanonicalModal";
import Input from "../../components/BaseComponents/Forms/Input";
import OrganisationJurisdictionSelect from "../../components/BaseComponents/OrganisationJurisdictionSelect";
import useApi from "../../hooks/useApi";
import { getApiErrorMessage, getCSRFToken } from "../../lib/utils";

type CreateTrainingSessionModalProps = {
    onClose: () => void,
    onCreated: (newId: string) => void,
    isOpen?: boolean,
};

function CreateTrainingSessionModal({ onClose, onCreated, isOpen }: CreateTrainingSessionModalProps) {
    const [name, setName] = useState('');
    // Blank means no gate - the session starts immediately. See Decision 11 in
    // docs/todo/admin-user-training-sessions.md.
    const [startDate, setStartDate] = useState('');
    // Sub-task I Phase 4 (docs/todo/user-org-membership-i-signup-jurisdiction-harmonisation.md):
    // default jurisdiction for any training org created within this session.
    const [jurisdictionCode, setJurisdictionCode] = useState<string | undefined>('EU');
    const api = useApi();
    const [error, setError] = useState('');

    const reset = () => {
        setName('');
        setStartDate('');
        setJurisdictionCode('EU');
        setError('');
    };

    const create = async () => {
        setError('');
        try {
            const result = await api.post('/admin/training-sessions', {
                name,
                startDate: startDate || undefined,
                jurisdictionCode,
                _csrf: await getCSRFToken(),
            })
            reset();
            onCreated(result.data.id);
        } catch (err: any) {
            setError(getApiErrorMessage(err, 'Failed to create this training session.'));
        }
    }

    return (
        <CanonicalModal
            open={!!isOpen}
            onClose={() => { reset(); onClose(); }}
            size="small"
            title="Create a new training session"
            actions={
                <>
                    <Button onClick={create} additionalClass="mr-5" disabled={!name} type="Primary" text="Create session" />
                    <Button onClick={onClose} type="Outlined" text="Cancel" />
                </>
            }
        >
            <Input
                label="Session name"
                name="sessionName"
                additionalClass="mt-8"
                value={name}
                onChange={e => setName(e.target.value)}
                type="text"
                placeholder="Session name..."
            />
            <Input
                label="Start date (optional - leave blank to start immediately)"
                name="startDate"
                additionalClass="mt-8"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                type="date"
            />
            <OrganisationJurisdictionSelect
                value={jurisdictionCode}
                onChange={setJurisdictionCode}
                label="Jurisdiction"
                isClearable={false}
                fillContainer
            />
            { error && (
                <InlineAlert type='error' className='mt-4'>{ error }
                </InlineAlert>
            )}
        </CanonicalModal>
    )
}

export default CreateTrainingSessionModal;

